import React from "react";
import { Kanban, KanbanTask } from "@planzone/dto";
import { Filter, StatusFilters } from "../types";

function isFinished(filter: Filter, task: KanbanTask) {
  return (
    filter.statuses.includes(StatusFilters.FINISHED) &&
    task.percentComplete === 100
  );
}

function isStarted(filter: Filter, task: KanbanTask) {
  return (
    filter.statuses.includes(StatusFilters.STARTED) && task.percentComplete > 0
  );
}

function isNotStarted(filter: Filter, task: KanbanTask) {
  return (
    filter.statuses.includes(StatusFilters.PLANNED) &&
    task.percentComplete === 0
  );
}

function filterTasks(filter: Filter, task: KanbanTask) {
  return (
    isFinished(filter, task) ||
    isStarted(filter, task) ||
    isNotStarted(filter, task)
  );
}

function applyFilter(kanban: Kanban, filter: Filter): Kanban {
  return {
    ...kanban,
    columns: kanban.columns.map((column) => ({
      ...column,
      tasks: column.tasks.filter((task) => filterTasks(filter, task)),
    })),
  };
}

const filterInitialState: Filter = {
  resources: [],
  groups: [],
  projectsElementsTags: [],
  resourceTags: [],
  statuses: [
    StatusFilters.FINISHED,
    StatusFilters.STARTED,
    StatusFilters.PLANNED,
  ],
};

const FilterContext = React.createContext({
  filter: filterInitialState,
  setFilter: (nextFilter: Filter) => {},
});

function useFilter() {
  return React.useContext(FilterContext);
}

export { applyFilter, useFilter, filterInitialState, FilterContext };
